import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=d620ee76&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=ts&"
export * from "./Error.vue?vue&type=script&lang=ts&"
import style0 from "./Error.vue?vue&type=style&index=0&id=d620ee76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d620ee76",
  null
  
)

export default component.exports